export default __webpack_public_path__ + "static/media/How 1-3.1bd94e0f.svg";